// src/components/common/SuperAdminRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const SuperAdminRoute = ({ children }) => {
  const userStr = localStorage.getItem("user");

  if (!userStr) {
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);

    if (user.role !== "admin") {
      toast.error("Access Denied: You do not have Super Admin privileges.");
      return <Navigate to="/user-dashboard" replace />;
    }

    return children;
  } catch (error) {
    console.error("Error verifying admin role in SuperAdminRoute:", error);
    return <Navigate to="/login" replace />;
  }
};

export default SuperAdminRoute;
